exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bottom-bar[data-v-65991345]{text-align:center;font-size:12px;display:block;position:fixed;bottom:0;left:0;width:100%;padding-left:200px;background:#f8fffd\n}\n.route-view[data-v-65991345]{padding:20px 20px;-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:calc(100% - 200px);overflow:auto;background:#f8fffd\n}\n.route-index[data-v-65991345]{overflow:hidden;height:100%;width:100%\n}\n.main[data-v-65991345]{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:hidden;height:calc(100% - 82px);width:100%\n}", ""]);

// exports
